import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ApiServices } from 'src/app/shared/services/api.service';
import { DataService } from 'src/app/shared/services/data.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import { MetaService } from 'src/app/shared/services/meta.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {

  form: FormGroup;
  processing = false;
  subscriptions = new Subscription();

  constructor(
    private apiService: ApiServices,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private dataService: DataService,
    private metaService: MetaService,
    private activatedRoute: ActivatedRoute,
    private helperService: HelperService,
    private router: Router
  ) {


    const token = localStorage.getItem('ts_vendor_access_token');
    if(token) {
      this.apiService.myAccount().subscribe(
        response => {
          this.dataService.myAccountData.next(response.data);
          this.dataService.isLoggedIn.next(true);
          this.router.navigateByUrl('/my-account/my-profile');
        }, error => {
          this.helperService.logout();
        }
      );
    }

    this.form = this.fb.group({
      email: [this.activatedRoute.snapshot.queryParams.email, [Validators.required]],
      token: [this.activatedRoute.snapshot.queryParams.token, [Validators.required]],
      password: ['', [Validators.required]],
      password_confirmation: ['', [Validators.required]],
    }, {
      validators: this.passwordMatchValidator
    });

    helperService.setPageTitle(activatedRoute.snapshot.data.title);
  }

  passwordMatchValidator(group: FormGroup) {
    const password = group.get('password').value;
    const confirmPassword = group.get('password_confirmation').value;

    return password === confirmPassword ? null : { passwordMismatch: true };
  }

  ngOnInit(): void {
  }

  onResetPassword() {
    this.processing = true;
    this.subscriptions.add(
      this.apiService.resetPassword(this.form.value).subscribe(
        (response) => {
          this.processing = false;
          this.toastr.success(response.message);
          this.router.navigateByUrl('/login');
        },
        (error) => {
          this.processing = false;
          this.toastr.error(error.error.message);
        }
      )
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
